import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["value"]

  connect() {
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.animate()
        this.observer.disconnect()
      }
    }, { threshold: 0.35 })

    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  animate() {
    const duration = 1500
    const startedAt = performance.now()

    const frame = (timestamp) => {
      const progress = Math.min((timestamp - startedAt) / duration, 1)
      const easedProgress = 1 - ((1 - progress) ** 3)

      this.valueTargets.forEach((valueTarget) => {
        const value = Number(valueTarget.dataset.value)
        const suffix = valueTarget.dataset.suffix || ""
        valueTarget.textContent = `${Math.round(value * easedProgress)}${suffix}`
      })

      if (progress < 1) window.requestAnimationFrame(frame)
    }

    window.requestAnimationFrame(frame)
  }
}
